import { v4 as uuidv4 } from 'uuid';

export const getShoppingFinishedId = () => {
  return uuidv4().replace(/-/g, '');
};
